export default __webpack_public_path__ + "static/media/csvSuccess.25c8dd39.svg";